module.exports = __webpack_public_path__ + "fonts/iconfont.dbeca70b.woff";